import type { BackupIncrStatus } from "./useBackupIncr";

function label(state: BackupIncrStatus | null): string {
  if (!state) return "Sauvegarde…";
  if (state.running) return "Sauvegarde OK";
  if (state.status === "PERIME" || (state.age_sec !== null && state.age_sec > 720)) {
    return "Sauvegarde en retard";
  }
  if (state.status === "INJOIGNABLE" || state.status === "MANQUANT") {
    return "Sauvegarde absente";
  }
  return "Sauvegarde en alerte";
}

function title(state: BackupIncrStatus | null): string {
  if (!state) return "Sauvegarde : contrôle…";
  const files =
    state.live_files !== null && state.dest_files !== null
      ? ` · ${state.live_files}/${state.dest_files} fichiers`
      : "";
  const when = state.date ? ` · ${state.date}` : "";
  return `${label(state)}${when}${files}`;
}

type BackupPillProps = {
  state: BackupIncrStatus | null;
  onClick: () => void;
};

export function BackupPill({ state, onClick }: BackupPillProps) {
  const ok = Boolean(state?.running);
  return (
    <button
      type="button"
      className={`fx-bak-pill${ok ? " is-ok" : state ? " is-bad" : ""}`}
      title={title(state)}
      aria-label={title(state)}
      onClick={onClick}
    >
      <span className="fx-bak-pill__dot" aria-hidden />
      <span>{ok ? "Sauvegarde" : state ? "Sauvegarde" : "…"}</span>
    </button>
  );
}

export function backupLiveLine(state: BackupIncrStatus | null): { ok: boolean; text: string } {
  if (!state) return { ok: false, text: "État en cours de lecture…" };
  const files =
    state.live_files !== null && state.dest_files !== null
      ? ` ${state.live_files} / ${state.dest_files} fichiers.`
      : "";
  if (state.running) {
    return { ok: true, text: `Copie de secours active.${state.date ? ` Dernier contrôle ${state.date}.` : ""}${files}` };
  }
  return {
    ok: false,
    text: `Copie de secours à l’arrêt.${state.date ? ` Dernier contrôle : ${state.date}.` : ""} Un e-mail d’alerte part si ça dure.`,
  };
}
